import { useCallback, useState } from "react";

import { CURRENT_USER } from "../constants";
import { User } from "../models/user";

export default function useCurrentUser() {
  const [currentUser, _setCurrentUser] = useState<User | undefined>(
    window.localStorage.getItem(CURRENT_USER)
      ? JSON.parse(window.localStorage.getItem(CURRENT_USER) || "")
      : undefined
  );

  const setCurrentUser = useCallback((user?: User) => {
    if (user) {
      window.localStorage.setItem(CURRENT_USER, JSON.stringify(user));
    } else {
      window.localStorage.removeItem(CURRENT_USER);
    }
    _setCurrentUser(user);
  }, []);

  return [currentUser, setCurrentUser] as const;
}
